/**
 * Created by mateimisarca on 21/09/2020
 */

export const USER_REQUEST = 'app/UserContainer/USER';
export const PROFILE_UPDATE_REQUEST = 'app/UserContainer/PROFILE_UPDATE';

export const API_USER_PROFILE = '/api/profile';
